import React from "react";
import "./Inner.css";

export default function About() {
  return (
    <>
      <section className="page-hero">
        <div className="container">
          <span className="eyebrow" style={{ color: "#F2FAFA" }}>About Us</span>
          <h1>Our Story</h1>
        </div>
      </section>

      <section>
        <div className="container narrow">
          <p>HearMenders was created to solve one simple problem:</p>
          <p className="lede">Too many people who need hearing care never receive it.</p>
          <ul className="plain-list">
            <li>Some don't know where to go.</li>
            <li>Some cannot afford hearing aids.</li>
            <li>Others receive hearing aids but lack the support they need afterwards.</li>
          </ul>
          <p>We're changing that.</p>
          <p>
            HearMenders combines professional hearing care, technology, and innovative financing
            to make hearing care more accessible for everyone.
          </p>
        </div>
      </section>

      <section className="split-band">
        <div className="container split-grid">
          <div className="split-card">
            <span className="eyebrow">Our Vision</span>
            <h2>Where we're headed</h2>
            <p>
              To become Africa's leading digital hearing care platform, connecting people to
              quality hearing care through innovation, accessibility, and affordability.
            </p>
          </div>
          <div className="split-card">
            <span className="eyebrow">Our Mission</span>
            <h2>What drives us</h2>
            <p>
              To remove barriers to hearing care by connecting people with licensed
              professionals, providing access to hearing solutions, and supporting them
              throughout their hearing journey.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
